<template>
  <div>
    <hilight></hilight>
  </div>
</template>

<script>
// import Vue from 'vue'
import hilight from '@/components/HilightHome.vue'

export default {
  name: 'app-hilight',
  components: { hilight }
}

// new Vue({
//   render: h => h(hilight)
// }).$mount('#hilight-home')
</script>
